'use client';

import { FreestarBootstrap } from '@benzinga/ads';
import { resolveRouteMetaDisableFooterDisplayAd } from '../../_libs/site-shell/routeMeta';
import { useRouteMeta } from './RouteMetaContext';

export function FreestarBootstrapWithRouteMeta({
  disableFooterDisplayAd,
  targeting,
}: {
  disableFooterDisplayAd?: boolean;
  targeting?: Record<string, string | string[]>;
}) {
  const routeMeta = useRouteMeta();
  const footerDisplayAdDisabled = routeMeta
    ? resolveRouteMetaDisableFooterDisplayAd(routeMeta)
    : !!disableFooterDisplayAd;

  return (
    <FreestarBootstrap
      disableFooterDisplayAd={footerDisplayAdDisabled || !!disableFooterDisplayAd}
      targeting={routeMeta?.pageTargeting ?? targeting}
    />
  );
}
